import { api } from '@/api/axiosInstance';
import { ApiErrorResponse, ApiResponseType } from '@/api/type/commonTypes';

interface deletePartnerConfirmFileProps {
  orderId: string;
  confirmationFileId: string;
}

// 파트너 컨펌 파일 삭제
export const deletePartnerConfirmFile = async (
  data: deletePartnerConfirmFileProps
) => {
  const res = await api.delete<ApiErrorResponse>(
    `/api/web/partners/orders/confirm/files`,
    {
      data,
    }
  );
  return res.data;
};
